import { saveSubItem, loadSubItem } from 'app/common/helpers/storage';
import { get } from 'app/common/helpers/fetch';
import { SUBNAV_STORAGE } from 'app/common/constants/storage-keys';
import { CACHE_DURATION_HOUR } from 'app/common/constants/caching';

function transformCards(cards) {
  if (!Array.isArray(cards)) {
    return {};
  }

  return cards.reduce(
    (acc, card) =>
      Object.assign(acc, {
        [card.group]: card,
      }),
    {}
  );
}

function getSubnavCacheKey(division) {
  return `${division}:${Groupon.App.name}`;
}

/** Fetch primary & subnav from server */
function fetchNavigation(division) {
  const url = `/layout/api/v2/subnav`;
  const { utm_campaign, utm_medium, utm_source } = window.location.search;
  const utm_params = {
    ...(utm_campaign && { utm_campaign }),
    ...(utm_medium && { utm_medium }),
    ...(utm_source && { utm_source }),
  };

  // load from server
  return get(url, utm_params).then(({ flyouts, cards, nav }) => {
    const noFlyouts = !flyouts || !Object.keys(flyouts).length;
    const noCards = !Array.isArray(cards);
    const transformedCards = transformCards(cards);

    if (noFlyouts) flyouts = {}; // just return an empty object
    if (noCards) cards = []; // just return an empty array

    if (!(noFlyouts || noCards)) {
      // save to local storage
      saveSubItem(
        SUBNAV_STORAGE,
        getSubnavCacheKey(division),
        { nav, flyouts, cards },
        CACHE_DURATION_HOUR
      );
    }

    return { nav, flyouts, cards: transformedCards };
  });
}

/**
 * Load subnav flyouts and cards from localstorage or server
 *
 * @param {Object} location - location from reducer
 */
export function loadNavigationData(location) {
  const { division } = location;

  // load local storage first
  const cachedData = loadSubItem(SUBNAV_STORAGE, getSubnavCacheKey(division));

  // if we got data from local storage, just return it
  if (
    cachedData &&
    cachedData.hasOwnProperty('nav') &&
    cachedData.hasOwnProperty('cards') &&
    cachedData.hasOwnProperty('subnav')
  ) {
    return Promise.resolve({
      ...cachedData,
      cards: transformCards(cachedData.cards),
    });
  }

  // fetch data from server
  return fetchNavigation(division);
}
